import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const url = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? "";

/** False when .env is missing or incomplete — app should show setup instructions instead of a blank screen. */
export const isSupabaseConfigured = Boolean(url && key);

// createClient throws if URL or key is empty; use placeholders so the module loads and React can render.
const SUPABASE_URL = isSupabaseConfigured
  ? url
  : "https://configure-env-placeholder.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = isSupabaseConfigured
  ? key
  : "sb_publishable_key_missing_configure_dotenv";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
